import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  selectedGeoBoundary: [],
  isInitialized: false
}

const geographicBoundarySlice = createSlice({
  name: 'geographicBoundary',
  initialState,
  reducers: {
    setSelectedGeoBoundary: (state, action) => {
      state.selectedGeoBoundary = action.payload
    },
    setGeoBoundaryInitialized: (state, action) => {
      state.isInitialized = action.payload
    },
    clearGeographicBoundary: (state) => {
      state.selectedGeoBoundary = []
      state.isInitialized = false
    }
  }
})

export const {setSelectedGeoBoundary, setGeoBoundaryInitialized, clearGeographicBoundary} =
  geographicBoundarySlice.actions

export const selectSelectedGeoBoundary = (state) => state.geographicBoundary.selectedGeoBoundary
export const selectIsGeoBoundaryInitialized = (state) => state.geographicBoundary.isInitialized

export default geographicBoundarySlice.reducer
